import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=912adcdc&scoped=true"
import script from "./commonHeader.vue?vue&type=script&lang=js"
export * from "./commonHeader.vue?vue&type=script&lang=js"
import style0 from "./commonHeader.vue?vue&type=style&index=0&id=912adcdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912adcdc",
  null
  
)

export default component.exports